// extracted by css-extract-rspack-plugin
export default {"menu-button":"CopilotCodeLinesMenu-module__menu-button__zMqLOmq"};